import { isArray, isEmpty } from 'lodash';
import BaseType from './Base';

export default {
  ...BaseType,
  load(value) {
    return value || this.default();
  },
  dump(value) {
    return value || this.default();
  },
  isPresent(value) {
    return value && !isEmpty(value);
  },
  loadErrors(errors) {
    if (isArray(errors)) return { base: errors };
    return errors || {};
  },
};



// WEBPACK FOOTER //
// ./mixins/Form/Types/NullableObject.js